export default {
  methods: {
    isValidEmail(email) {
      let emailPattern =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let isValidEmail = emailPattern.test(email);
      return isValidEmail;
    },
    isPhoneNumber(phone){
      let phonePattern = /^[+]?\d+$/;
      let isValidPhone = phonePattern.test(phone)
      return isValidPhone
    },
  }
}
